import { render, staticRenderFns } from "./platformCount.vue?vue&type=template&id=b97e84cc"
import script from "./platformCount.vue?vue&type=script&lang=js"
export * from "./platformCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports